module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_google":"Search in Google","search_google_trends":"Search in Google trends"},"fr":{"search_google":"Lancer recherche dans Google","search_google_trends":"Lancer recherche dans Google Trends"},"de":{"search_google":"Suche in Google starten","search_google_trends":"Suche in Google Trends starten"}}')
  delete Component.options._Ctor
}
